var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{staticStyle:{"height":"200px"},attrs:{"columns":_vm.columns,"data-source":_vm.snapshot.history,"row-key":"timestamp","scroll":{
      x: _vm.scrollX
    },"size":"small"},scopedSlots:_vm._u([{key:"timestamp",fn:function(record){return [_vm._v(" "+_vm._s(_vm._f("humanTimestamp")(record))+" ")]}},{key:"value",fn:function(record){return [_c('a-tooltip',{attrs:{"placement":"topLeft","title":record}},[_vm._v(_vm._s(record))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }